import React from "react";
import {
  Award,
  BarChart,
  Brain,
  Briefcase,
  Calendar,
  Clock,
  Compass,
  Facebook,
  Globe,
  GripVertical,
  Heart,
  Home,
  Instagram,
  Lightbulb,
  Linkedin,
  MapPin,
  MessageCircle,
  Mic,
  Palette,
  Rocket,
  Search,
  Star,
  Target,
  Trophy,
  Users,
  Youtube,
} from "lucide-react";
import { ICON_NAMES, type TIconName } from "~/lib/icon-names";
import { IconD } from "./icon-d";

export const iconMap: Record<
  TIconName,
  {
    component: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    label: string;
  }
> = {
  award: { component: Award, label: "Award" },
  barChart: { component: BarChart, label: "Bar Chart" },
  brain: { component: Brain, label: "Brain" },
  briefcase: { component: Briefcase, label: "Briefcase" },
  compass: { component: Compass, label: "Compass" },
  heart: { component: Heart, label: "Heart" },
  lightbulb: { component: Lightbulb, label: "Lightbulb" },
  rocket: { component: Rocket, label: "Rocket" },
  star: { component: Star, label: "Star" },
  target: { component: Target, label: "Target" },
  trophy: { component: Trophy, label: "Trophy" },
  users: { component: Users, label: "Users" },
  globe: { component: Globe, label: "Globe" },
  facebook: { component: Facebook, label: "Facebook" },
  instagram: { component: Instagram, label: "Instagram" },
  linkedin: { component: Linkedin, label: "LinkedIn" },
  youtube: { component: Youtube, label: "YouTube" },
  message: { component: MessageCircle, label: "Message" },
  location: { component: MapPin, label: "Location" },
  palette: { component: Palette, label: "Palette" },
  mic: { component: Mic, label: "Mic" },
  calendar: { component: Calendar, label: "Calendar" },
  clock: { component: Clock, label: "Clock" },
  home: { component: Home, label: "Home" },
  search: { component: Search, label: "Search" },
  dcm: { component: IconD, label: "Dream Coach Match" },
  "grip-vertical": { component: GripVertical, label: "Grip Vertical" },
} as const;

export const NamedIcon = (props: { name: string; className?: string }) => {
  if (ICON_NAMES.includes(props.name as TIconName)) {
    const IconComponent = iconMap[props.name as TIconName].component;
    return <IconComponent className={props.className} />;
  }
  return null;
};
